import {Component, OnDestroy, OnInit} from '@angular/core';
import {UtilsService} from "../../../../core/utils/utils.service";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {Udp_ModeleConditionnementPlat__ProduitDTO} from "../../../../core/dtos/unite-de-production_modele-conditionnement-plat__produit.dto";
import {UdpMcpProduitsService} from "../../../../core/services/conditionnements/plat/udp-mcp-produits.service";
import {Subscription} from "rxjs/index";
import {ActivatedRoute} from "@angular/router";
import ModeleConditionnementPlatDTO from "../../../../core/dtos/conditionnement/modele-conditionnement-plat-dto";
import {RoutemapService} from "../../../../core/services/routemap.service";
import {ImplementationModelesConditionnementsPlatsService} from "../../../../core/services/conditionnements/plat/implementation-modeles-conditionnements-plats.service";
import {combineLatest} from "rxjs";
import {HELP_FOLDERS} from "../../../../core/constants";
import {confirm} from "devextreme/ui/dialog";
import {UniteDeProduction__ModeleConditionnementPlatDto} from "../../../../core/dtos/unite-de-production-modele-conditionnement-plat-dto";
import {ProduitDTO} from "../../../../core/dtos/produit-dto";
import {SiteService} from "../../../../core/site.service";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-mp-plats',
    templateUrl: './mp-plats.component.html',
    styleUrls: ['./mp-plats.component.scss'],
    standalone: false
})
export class PlatsComponent implements OnInit, OnDestroy {

  public ButtonThemeEnum = ButtonThemeEnum;

  platsList: Udp_ModeleConditionnementPlat__ProduitDTO[] = [];
  modelePlatConditionnement: ModeleConditionnementPlatDTO;

  isNotMonoSite: boolean;
  allMode: string;
  checkBoxesMode: string;
  selectedRows: number[] = [];

  subSupplier: Subscription;
  subBindPlatsSupplier: Subscription;
  private subAllSites: Subscription;
  subProductsAlreadyUsed: Subscription;

  hasIDistri = false;

  openDialogDisplayProductsAlreadyUsed: boolean = false;

  productsAlreadyUsed: ProduitDTO[] = [];

  pathFile: string = HELP_FOLDERS.CONDITIONNEMENT + '/conditionnement-modeles-plats-plats';

  constructor(public utils: UtilsService,
              private auth2Svc: Auth2Service,
              private udpMcpProduitsSvc: UdpMcpProduitsService,
              private route: ActivatedRoute,
              private routeMapSvc: RoutemapService,
              private implMcpSvc: ImplementationModelesConditionnementsPlatsService,
              private siteSvc: SiteService){

    this.allMode = 'allPages';
    this.checkBoxesMode = 'always';
  }

  ngOnDestroy(): void {
    this.productsAlreadyUsed = [];
    this.utils.unsubscribe(this.subSupplier);
    this.utils.unsubscribe(this.subBindPlatsSupplier);
    this.utils.unsubscribe(this.subProductsAlreadyUsed);
    this.utils.unsubscribe(this.subAllSites);
  }

  ngOnInit(): void {
    this.initMonoSite();
    this.initHasGestionIDistri();
    this.initDataFromSupplierSubscription();
    this.initListenerBindPlatsDoneSubscription();
    this.initListenerProductsAlreadyUsed();
  }

  initListenerBindPlatsDoneSubscription = () => {
    this.subBindPlatsSupplier = this.implMcpSvc.bindPlatsDone$
      .subscribe(() => {
        this.initUdpMcpProduitsList(this.modelePlatConditionnement.id);
      })
  };

  initListenerProductsAlreadyUsed = () => {
    this.subProductsAlreadyUsed = this.implMcpSvc.productsAlreadyUsed$
      .subscribe((productsAlreadyUsed) => {
        this.openDialogDisplayProductsAlreadyUsed = true;
        this.productsAlreadyUsed = productsAlreadyUsed;
      });
  }

  initDataFromSupplierSubscription = () => {
    this.subSupplier = this.route.parent.data
      .subscribe((data: any) => {
        if (data.modelePlatSupplier) {
          this.modelePlatConditionnement = data.modelePlatSupplier.modelePlatConditionnement;
          this.initUdpMcpProduitsList(data.modelePlatSupplier.idModeleConditionnementPlat);
        }
      });
  };

  initUdpMcpProduitsList = (mcpId): void => {
    this.udpMcpProduitsSvc.findAllByMcpId(mcpId)
      .subscribe(response => {
        this.platsList = response.resultList
      });
  };

  initHasGestionIDistri = (): void => {
    this.auth2Svc.hasGestionIDistri$.subscribe(response => this.hasIDistri = response);
  };

  visualize(instance: Udp_ModeleConditionnementPlat__ProduitDTO): void {
    this.routeMapSvc.goToSecondaryRoute(['gestionproduits', 'produit', instance.produit.typeProduit.fabrique, instance.produit.id, 'conditionnement-visualization', instance.udp__modeleConditionnementPlat.id]);
  }

  canEdit = (): boolean => this.hasIDistri;

  help = (): void => {

  };

  openDialogAjoutPlats = (): void => {
    this.udpMcpProduitsSvc.openDialogBindWithPlats(this.modelePlatConditionnement);
  };

  deleteValues = async (): Promise<void> => {
    const result = confirm('Êtes-vous sûr de vouloir supprimer le(s) association(s) sélectionnée(s) ?', 'Suppression d\'association');
    const isDeleted: boolean = await result;
    if(isDeleted) {
      const platsSelectedList = this.selectedRows.map(id => this.platsList.find(plat => plat.id === id));
      const subDeletionsList = [];
      platsSelectedList.forEach(plat => {
        subDeletionsList.push(this.implMcpSvc.delete([plat.udp__modeleConditionnementPlat.id], undefined, undefined, plat.produit.id));
      });
      combineLatest(subDeletionsList)
        .toPromise()
        .then(deletions => {
          this.initUdpMcpProduitsList(this.modelePlatConditionnement.id);
        });
    }
  };

  linkToFicheTechnique = (idProduit: number, dataUdp: UniteDeProduction__ModeleConditionnementPlatDto): void => {
    if (idProduit && dataUdp)
      this.routeMapSvc.goToSecondaryRoute(['gestionproduits', 'produit', true, idProduit, 'fichetechnique-preselection-by-udp', dataUdp.idUniteDeProduction]);
  }

  private initMonoSite() {
    this.subAllSites = this.siteSvc.getListeSitesActifs().subscribe(response => {
      this.isNotMonoSite = response.length !== 1;
      console.log("isnotmonosite" + this.isNotMonoSite)
    });
  }
}
